export default function serverurl(url, forceRemote = false) {
    const IS_DEV = process.env.NODE_ENV === 'test';
    const localUrl = 'http://localhost:3000/';
    const remoteUrl = 'https://jamos-v2.herokuapp.com/';
    return forceRemote ? `${remoteUrl}${url}` : `${IS_DEV ? localUrl : remoteUrl}${url}`;
}
